module.exports = __webpack_public_path__ + "29f80b00a7b4641183f96f08be374697.ttf";